import type { SxProps, Theme } from '@mui/material';
import { colors } from '../../core/theme/theme';

/**
 * DataGrid theming aligned with docs/design/mui-design-guide.md:
 * - Border radius 0
 * - No shadows
 * - Column headers on #EDEDED, bold, with 2px bottom border in body text color
 * - Row borders in light gray, peach hover
 */
export const adminDataGridSx: SxProps<Theme> = {
  borderRadius: 0,
  border: `1px solid ${colors.lightGray}`,
  boxShadow: 'none',
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: colors.lightGray,
    borderBottom: `2px solid ${colors.bodyText}`,
    borderRadius: 0,
  },
  '& .MuiDataGrid-columnHeader': {
    fontWeight: 700,
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 700,
  },
  '& .MuiDataGrid-cell': {
    borderBottom: `1px solid ${colors.lightGray}`,
    fontSize: '14px',
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: colors.peach,
  },
  '& .MuiDataGrid-footerContainer': {
    borderTop: `1px solid ${colors.lightGray}`,
  },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
    {
      outline: 'none',
    },
};
